import styled from "styled-components"

export const StyledCard = styled.div`
    text-align: center;
    background: yellow;
    padding: 60px 80px;
    align-items: center;
    background: #ffffff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 14px;
    letter-spacing: 0.05em;
    margin: 16px 0;
`